import { model as i18n } from '!/i18n'
import { combine } from 'effector'

export const $notificationTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('unavailable_features_error'),
}))
